// Local BackEnd:
// export const API_BASE_URL = `http://localhost:5000`;   

// Deployed/Live Heroku BackEnd:
export const API_BASE_URL = `https://my200-notes-backend.herokuapp.com`; 

// Final URL:
export const API_URL = `${API_BASE_URL}/notes`;

// export default API_URL;

